import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Bell = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      clipRule="evenodd"
      d="M13 4.07645C16.1151 4.55745 18.5 7.25021 18.5 10.5V11.7132L19.8917 13.94C20.7243 15.2721 19.7666 17 18.1958 17H5.80425C4.23337 17 3.27569 15.2721 4.10825 13.94L5.5 11.7132V10.5C5.5 7.25021 7.88491 4.55745 11 4.07645V2H13V4.07645ZM12 6C9.51472 6 7.5 8.01472 7.5 10.5V12.2868L5.80425 15H18.1958L16.5 12.2868V10.5C16.5 8.01472 14.4853 6 12 6Z"
      fill="currentColor"
      fillRule="evenodd"
    />
    <path
      d="M12 19C12.5523 19 13 18.5523 13 18H15C15 19.6569 13.6569 21 12 21C10.3431 21 9 19.6569 9 18H11C11 18.5523 11.4477 19 12 19Z"
      fill="currentColor"
    />
  </Icon>
));

export default Bell;
